import {
  AtlasBodyMain,
  CardComponent,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { useTranslation } from 'react-i18next'
import { StackAtom } from 'components/atoms/Stack.atom'

export interface TransferCardProps {
  location?: string
  warehouse: string
  containersQty: number
  processedSKUs: number
  totalSKUs: number
  status: string
  docNum: string
  onClick?: () => void
}

const STATUS_COLORS: Record<string, { text: string; bg: string }> = {
  pending: { text: '#E87C03', bg: '#E87C031A' },
  inProgress: { text: '#2C82F2', bg: '#2C82F21F' },
  readyToWrap: { text: '#2C82F2', bg: '#2C82F21F' },
  readyForLoading: { text: '#2C82F2', bg: '#2C82F21F' }
}

export const TransferCard = (props: TransferCardProps) => {
  const {
    location = 'ARMADO-1',
    warehouse,
    containersQty,
    processedSKUs,
    totalSKUs,
    status,
    docNum,
    onClick
  } = props
  const { t } = useTranslation('global')

  return (
    <CardComponent onClick={onClick}>
      <StackAtom $direction="column" $gap={4}>
        <StackAtom $justify="space-between">
          <StackAtom $gap={4} $align="center">
            <TagMolecule
              bgColor="#D9515B"
              textColor="#fff"
              shape="rounded"
              icon={<Icon name="arrow_up" color="white" size={18} />}
            />
            <AtlasBodyMain style={{ fontWeight: 700 }}>{docNum}</AtlasBodyMain>
          </StackAtom>

          <TagMolecule
            text={t(`commons.${status}`)}
            bgColor={STATUS_COLORS[status].bg}
            textColor={STATUS_COLORS[status].text}
          />
        </StackAtom>

        <StackAtom $align="center" $gap={4}>
          <TagMolecule
            bgColor="#212121"
            shape="rounded"
            icon={<Icon name="ic_location" color="white" size={18} />}
          />
          <AtlasBodyMain>{location}</AtlasBodyMain>
        </StackAtom>

        <StackAtom $align="center" $gap={8}>
          <TagMolecule text={warehouse} style={{ width: '80px' }} />
          <TagMolecule
            text={`${containersQty}`}
            icon={<Icon name="ic_pallet" size={18} color="white" />}
            style={{ width: '80px' }}
          />
          <TagMolecule
            text={`${processedSKUs}/${totalSKUs}`}
            icon={<Icon name="ic_product" size={18} color="white" />}
            style={{ width: '90px' }}
          />
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
